
/**
 * 강의 난이도
 * @nullable
 */
export type UpdateCourseDraftBodyLevel = typeof UpdateCourseDraftBodyLevel[keyof typeof UpdateCourseDraftBodyLevel] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraftBodyLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
